<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th(width="7%")
          span(:title="$t('ui.id')") {{ $t('ui.id') }}
        template(v-if="operatorView == false")
          th(width="7%")
            span(:title="$t('ui.ref_no')") {{ $t('ui.ref_no') }}
          th(width="7%")
            span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
        th(width="7%")
          span(:title="$t('ui.member')") {{ $t('ui.member') }}
        th.text-right(width="5%")
          span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
        template(v-if="operatorView == false")
          th(width="10%")
            span(:title="$t('ui.sender_bank')") {{ $t('ui.sender_bank') }}
          th(width="10%")
            span(:title="$t('ui.sender_bank_acc_holder')") {{ $t('ui.sender_bank_acc_no') }}
          th(width="10%")
            span(:title="$t('ui.sender_bank_acc_holder')") {{ $t('ui.sender_bank_acc_holder') }}
        th(width="10%")
          span(:title="$t('ui.receiver_bank')") {{ $t("ui.receiver_bank") }}
        th(width="10%")
          span(:title="$t('ui.receiver_bank_acc_no')") {{ $t("ui.receiver_bank_acc_no") }}
        th(width="10%")
          span(:title="$t('ui.receiver_bank_acc_holder')") {{ $t("ui.receiver_bank_acc_holder") }}
        th(width="10%" v-if="['ARS','AUD'].includes(getCurrencyCode)")
          template(v-if="['AUD'].includes(getCurrencyCode)")
            span(:title="$t('ui.bsb')") {{ $t("ui.bsb") }}
          template(v-else)
            span(:title="$t('ui.cuit')") {{ $t("ui.cuit") }}
        th(width="10%" v-if="['AUD'].includes(getCurrencyCode)")
          span(:title="$t('ui.payid')") {{ $t("ui.payid") }}
        th(width="5%")
          span(:title="$t('ui.upline')") {{ $t("ui.upline") }}
        th(width="5%")
          span(:title="$t('ui.vip')") {{ $t("ui.vip") }}
        th.text-center(width="5%")
          span(:title="$t('ui.status')") {{ $t("ui.status") }}
        template(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
          th(width="6%")
            span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
          th(width="5%")
            span(:title="$t('ui.review_by')") {{ $t("ui.review_by") }}
          th(width="5%")
            span(:title="$t('ui.audit_by')") {{ $t("ui.audit_by") }}
          th.text-right(width="10%")
            span(:title="$t('ui.audit_time_modified')") {{ $t("ui.audit_time_modified") }}
        th.text-right.sortable(width="10%")
          span(:title="$t('ui.submit_time')") {{ $t("ui.submit_time") }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(:colspan="ticketStatus.trim().toUpperCase() != 'PENDING' ? '22' : '18'").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl" :class="$helpers.rowClassTicket(item, 'withdrawal')")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span.d-block(:title="item.id") {{ item.id }}&nbsp;
        template(v-if="operatorView == false")
          td
            span.small.text-info.d-block(:title="getRefNo(item.sender_bank_id, item.id, item.prefix_w, item.prefix_delimiter)") {{ getRefNo(item.sender_bank_id, item.id, item.prefix_w, item.prefix_delimiter) }}
          td
            span(:title="item.parent_id") {{ item.parent_id }}&nbsp;
        td
          span(:title="item.member_id") {{ item.member_id }}&nbsp;
        td.text-right
          span.font-weight-bold.d-block(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
        template(v-if="operatorView == false")
          td
            span(:title="item.sender_bank_id") {{ item.sender_bank_id }}&nbsp;
          td
            span(:title="item.sender_bank_acc_no") {{ item.sender_bank_acc_no }}&nbsp;
          td
            span(:title="item.sender_bank_acc_holder") {{ item.sender_bank_acc_holder }}&nbsp;
        td
          span(:title="item.target_bank_id") {{ item.target_bank_id }}&nbsp;
        td
          span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}&nbsp;
        td
          span(:title="item.target_bank_acc_holder") {{ item.target_bank_acc_holder }}&nbsp;
        td(v-if="['ARS','AUD'].includes(getCurrencyCode)")
          span(:title="item.target_bank_acc_remark") {{ item.target_bank_acc_remark }}&nbsp;
        td(v-if="['AUD'].includes(getCurrencyCode)")
          span(:title="item.target_bank_acc_remark_2") {{ item.target_bank_acc_remark_2 }}&nbsp;
        td
          span(:title="item.referrer_id") {{ item.referrer_id }}&nbsp;
        td
          span(:title="item.vip_name") {{ item.vip_name }}&nbsp;
        td.text-center
          span(v-if="item.status.trim().toUpperCase() == 'PENDING'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
          span(v-if="item.status.trim().toUpperCase() == 'PROCESSED'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
          span(v-if="item.status.trim().toUpperCase() == 'REJECTED' && item.reject_approved == false" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
          span(v-if="item.status.trim().toUpperCase() == 'PROCESSING'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
          span(v-if="item.status.trim().toUpperCase() == 'REVIEW'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
          span(v-if="item.status.trim().toUpperCase() == 'AUDIT'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
          span(v-if="item.status.trim().toUpperCase() == 'REJECTED' && item.reject_approved == true" :class="$helpers.badgeClass('processed')") {{ $t('ui.processed').toUpperCase() }}
          span(v-if="item.status.trim().toUpperCase() == 'REJECTED' && item.reject_approved == true" :class="$helpers.badgeClass(item.status)") ({{ $t('ui.rejected').toUpperCase() }})
        template(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
          td
            span(:title="item.remark") {{ item.remark }}&nbsp;
          td
            span(:title="item.review_by") {{ item.review_by }}&nbsp;
          td
            span(:title="item.audit_by") {{ item.audit_by }}&nbsp;
          td.text-right
            span(v-if="item.modified_date" :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
        td.text-right
          span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
    ticketStatus: {
      type: String,
      default: ""
    },
    operatorView: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  methods: {
    getRefNo: function(bank_id, id, prefix, delimiter) {
      return this.$helpers.getPaymentGatewayRefNoSetMember(bank_id, id, prefix, delimiter);
    },
  }
};
</script>
